// GlobalNotificationBar.tsx
import React, { FC, useState, useEffect, memo } from '../../../lib/teact/teact';
import './GlobalNotificationBar.css';

import store, { RootState } from '../store';
import { AppNotification, removeNotification } from '../redux/notificationsSlice';

interface GlobalNotificationBarProps {
  position?: 'fixed' | 'relative';      // cách position
  placement?: 'top' | 'bottom';         // nằm ở đỉnh hay đáy
  onNotificationClick?: (n: AppNotification) => void;
  autoHideMs?: number;                  // 0 = không tự ẩn
}

function selectCurrentNotification(state: RootState): AppNotification | undefined {
  const items = state.pushNotification.items;
  return items.length > 0 ? items[0] : undefined;
}

const GlobalNotificationBar: FC<GlobalNotificationBarProps> = ({
  position = 'fixed',
  placement = 'bottom',    // mặc định: đáy màn hình
  onNotificationClick,
  autoHideMs = 5000,
}) => {
  const [current, setCurrent] = useState<AppNotification | undefined>(
    selectCurrentNotification(store.getState() as RootState),
  );

  useEffect(() => {
    let last = selectCurrentNotification(store.getState());
    setCurrent(last);

    const unsubscribe = store.subscribe(() => {
      const next = selectCurrentNotification(store.getState());
      if (next?.id !== last?.id) {
        last = next;
        setCurrent(next);
      }
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!current) return;
    if (autoHideMs === 0) return;

    const timer = setTimeout(() => {
      store.dispatch(removeNotification(current.id));
    }, autoHideMs);

    return () => clearTimeout(timer);
  }, [current, autoHideMs]);

  if (!current) return null;

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    store.dispatch(removeNotification(current.id));
  };

  const handleClick = () => {
    onNotificationClick?.(current);
  };
  function truncateMessage(str: string, max = 100) {
    const chars = Array.from(str); // xử lý đúng emoji
    if (chars.length <= max) return str;
    return chars.slice(0, max).join('') + '...';
  }
  return (
    <div
      className={`gnb-container gnb-${position} gnb-${placement}`}
      onClick={handleClick}
      role="status"
      aria-live="polite"
    >
      <div className="gnb-content">
        <div className="gnb-title">{current.title}</div>
        <div className="gnb-message">{truncateMessage(current.message)}</div>
      </div>

      <button className="gnb-close" onClick={handleClose}>
        ×
      </button>
    </div>
  );
};

export default memo(GlobalNotificationBar);